/**
 * TopBar.tsx — 設計 v2 §4 **C02**（每頁頂欄：品牌／返回 ＋ 標題 ＋ 右上 **⋯**；唯一導航入口）
 *
 * 來源：`.coappery/tasks/J-ui-cosingery/design/components.jsx` C02（UI v2 **步 4**）
 *   · 三個狀態：`brand`（對話：品牌＋標題）／`back`（設定：返回＋標題）／`title`（日記：只有標題）
 *   · **⋯** 一律最右（`aria-haspopup="dialog"` → 右側抽屜）
 *   · ⚠️ 字串由 props 入（模組／元件零 i18n 依賴 → 由 caller 傳 `t(...)`）
 */
import BrandMark from './BrandMark';
import { Icons } from './Icons';

export interface TopBarProps {
  /** 顯示形態 */
  variant?: 'brand' | 'back' | 'title';
  /** 頁標題（已翻譯嘅文字） */
  title: string;
  /** `⋯` 掣嘅 aria-label（已翻譯） */
  menuLabel: string;
  onMenu: () => void;
  onBack?: () => void;
  onNewChat?: () => void;
  backLabel?: string;
  newChatLabel?: string;
}

export default function TopBar({
  variant = 'brand',
  title,
  menuLabel,
  onMenu,
  onBack,
  onNewChat,
  backLabel = '',
  newChatLabel = '',
}: TopBarProps) {
  return (
    <header className="shell__header">
      {variant === 'back' ? (
        <button type="button" className="icon-btn" onClick={onBack} aria-label={backLabel}>
          <Icons.Back />
        </button>
      ) : null}
      <div className="shell__brand">
        {variant === 'brand' ? <BrandMark size={28} /> : null}
        <h1 className="shell__title">{title}</h1>
      </div>
      <div className="topbar__spacer" />
      {onNewChat ? (
        <button type="button" className="icon-btn" onClick={onNewChat} aria-label={newChatLabel}>
          <Icons.NewChat />
        </button>
      ) : null}
      <button type="button" className="icon-btn" onClick={onMenu} aria-label={menuLabel} aria-haspopup="dialog">
        <Icons.More />
      </button>
    </header>
  );
}
